export default __webpack_public_path__ + "static/media/Example.5f38fc86.PNG";